import { render, staticRenderFns } from "./DocumentsTask.vue?vue&type=template&id=0fe7539b&scoped=true&"
import script from "./DocumentsTask.vue?vue&type=script&lang=js&"
export * from "./DocumentsTask.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsTask.vue?vue&type=style&index=0&id=0fe7539b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe7539b",
  null
  
)

export default component.exports